import styled from "styled-components";
import { Layout } from "antd";
import { Legal } from "./Legal";
import React, { FC } from "react";

export const OurLayout: FC<{ withoutFooter?: boolean; className?: string }> = ({
  children,
  withoutFooter,
  className,
}) => {
  return (
    <StyledLayout className={className}>
      <Layout.Content>{children}</Layout.Content>
      {!withoutFooter && (
        <StyledFooter>
          <Legal />
        </StyledFooter>
      )}
    </StyledLayout>
  );
};

const hideLegalHeight = () => {
  return `calc(
      100vh +
        ${document.querySelector("footer")?.clientHeight ?? 100}px`;
};

const StyledLayout = styled(Layout)`
  height: 100vh;
  @media screen and (max-width: 1000px) {
    height: ${hideLegalHeight()}
    );
  }

  background-color: var(--color-green-50);
`;

const StyledFooter = styled(Layout.Footer)`
  background-color: var(--color-green-100);
  a,
  button {
    color: white;
  }
`;

export const OurLayoutForNormalPages = styled(OurLayout)`
  .ant-layout-content {
    display: flex;
    align-items: center;
    padding-left: 8px;
    padding-right: 8px;
  }
`;
